export default __webpack_public_path__ + "18caafa5f0bf29d3bca2a94c44aa3e5c.png";